import React from 'react'
// import LoginForm from '../components/Login/LoginForm'
import SignIn from '../components/Login/Signin'

const Login = () => {
  return (
    <div className='App'>
      <div className="login-container">
        <SignIn />
      </div>
    </div>
  )
}

export default Login
